import React from 'react'
import Modal from 'react-modal'
import Scrollbar from 'react-scrollbars-custom'
import { useQuery } from '@tanstack/react-query'
import { getEventConfig } from '@/models/Config'
import { getUserRewardsOptions } from '@/client/@tanstack/react-query.gen'
import { getUserInfo } from '@/models/User'
import style from './Style.module.scss'
import dayjs from 'dayjs'

Modal.setAppElement('#root')

type Props = {
  modalStatus: boolean
  closeModal: () => void
}

const statusMap = {
  pending: 'Chờ xử lý',
  success: 'Thành công',
  failed: 'Thất bại',
  cancelled: 'Hủy bỏ',
  skipped: 'Bỏ qua',
} as const

const ModalHistory: React.FC<Props> = ({ modalStatus, closeModal }) => {
  const afterOpenModal = () => { }

  const settings = getEventConfig()
  const userData = getUserInfo()

  const { data: histories } = useQuery({
    ...getUserRewardsOptions(),
    enabled: !!userData?.id
  })

  const items = settings?.items ?? []

  const selfClose = (event: React.SyntheticEvent) => {
    event.preventDefault()
    const modalElement = document.querySelector('.swing-in-top-fwd')
    if (modalElement) {
      modalElement.classList.add('swing-out-top-bck')
    }
    setTimeout(() => closeModal(), 300)
  }

  const getTextUsage = (source: string | undefined): string => {
    if (source === 'spin') return 'Quà quay'
    if (source === 'acc_play_day') return 'Tích luỹ ngày chơi'
    if (source === 'acc_spin') return 'Tích luỹ spin'
    if (source === 'acc_new_mission') return 'Nhiệm vụ mới'
    if (source === 'acc_churn_mission') return 'Nhiệm vụ'
    if (source === 'acc_server') return 'Quà toàn server'
    if (source === 'acc_server_box') return 'Quà server box'
    if (source === 'shop') return 'Đổi quà'
    if (source === 'rank') return 'Quà hạng'
    return ''
  }

  return (
    <Modal
      isOpen={modalStatus}
      onAfterOpen={afterOpenModal}
      onRequestClose={selfClose}
      contentLabel="Lịch sử"
      portalClassName="ReactModalPortal"
      overlayClassName=""
      className="swing-in-top-fwd modal-history"
    >
      <div className="modal-description">
        <h2>Lịch sử nhận quà</h2>
        <div className={style.tableContainer}>
          <table className="table-history">
            <thead>
              <tr>
                <th style={{ width: '5%' }}>STT</th>
                <th style={{ width: '30%' }}>Tên VP</th>
                <th style={{ width: '20%' }}>Nhận từ</th>
                <th style={{ width: '20%' }}>Thời gian</th>
                <th style={{ width: '25%' }}>Trạng thái</th>
              </tr>
            </thead>
          </table>
          <div className={style.content}>
            <Scrollbar
              className="modal-history-scroll"
              style={{ height: '25vw' }}
              noScrollX
            >
              {histories?.userRewards?.length ? (
                <table className="table-history">
                  <tbody>
                    {histories.userRewards.map((data, index) => {
                      const item = items?.find((i) => i?.id === data?.itemId)
                      return (
                        <tr key={data?.id ?? index}>
                          <td style={{ width: '5%' }}>{index + 1}</td>
                          <td style={{ width: '30%' }}>{item?.name}</td>
                          <td style={{ width: '20%' }}>{getTextUsage(data?.source)}</td>
                          <td style={{ width: '20%' }}>
                            {data?.createdAt
                              ? dayjs(data.createdAt).format('DD/MM/YYYY HH:mm:ss')
                              : ''}
                          </td>
                          <td style={{ width: '25%' }}>
                            {data?.status
                              ? statusMap[data.status as keyof typeof statusMap]
                              : ''}
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              ) : (
                <div className={style.noData}>Chưa có lịch sử</div>
              )}
            </Scrollbar>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default ModalHistory
